module.exports = __webpack_public_path__ + "static/flags/EN-6d98d54829158cab0654ae3672ab7a06.gif";